export enum PROPOSTA_STATUS {
	ERROR = -1,
	PRE_ANALISE = 1,
	CARTA_CREDITO = 2,
	VISTORIA = 3,
	CONTRATACAO = 4,
	CONTRATADO = 5,
	CHECKLIST = 6,
	CONF_EMISSAO = 7,
	DOCUMENTO_CADASTRO = 8,
	DADOS_CADASTRO = 9,
	COMISSAO_CADASTRO = 10,
	ASSINATURA_CONTRATO = 11,
	COMPLIANCE_CADASTRO = 12,
	CARTORIO = 32
}
